import { requestCMS } from "utils/axiosInstance"
import { GeneralApiResponse } from "utils/types"

const logout = async () => {
  const res = await requestCMS.post<GeneralApiResponse<null>>(
    "/employee/logout",
    {}
  )
  return res
}

export default logout
